import styled from 'styled-components';

export const Container = styled.div`
  text-align: center;

  & > h3 {
    font-weight: 600;
    font-family: ${({ theme }) => theme.fonts.workSans};
    color: ${({ theme }) => theme.colors.grayDark3};
  }
`;

export const ModalContainer = styled.div`
  top: 0;
  left: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(25, 45, 56, 0.5);
`;

export const ProgressModal = styled.div`
  .hefesto-progress__label {
    display: none;
  }
  h3 {
    font-family: Source Sans Pro;
    font-size: 24px;
    font-weight: 600;
    line-height: 32px;
    text-align: left;
  }

  position: fixed;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 0.5rem;
  max-width: 564px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 2rem 0.5rem;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  & > P {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 2rem;
  }
`;
export const DivWrapperMessageChooseProduct = styled.div`
  margin-top: 1.5rem;
`;
